import { FC } from "react";
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { tableCellHeadStyle } from "../../common/styles/tableStyle";
import { TableFooterCommon } from "../../common/components/TableFooterCommon";
import { EditButton } from "../../common/components/EditButton";
import { DeleteTaskCounter } from "./DeleteTaskCounter";
import { TableCommonProps } from "../../common/types/tableType";

export const TaskCounterTable: FC<TableCommonProps> = ({
  data,
  page,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  setData,
  isLoading,
  setTotalRecords,
}) => {
  const navigate = useNavigate();

  const handleEdit = (id: number) => {
    navigate(`/update-task-counter-template/${id}`);
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 500 }} aria-label="task counter table">
        <TableHead sx={{ backgroundColor: "#F5F4F4" }}>
          <TableRow>
            <TableCell sx={tableCellHeadStyle}>
              Company
            </TableCell>
            <TableCell sx={tableCellHeadStyle}>Organization</TableCell>
            <TableCell sx={tableCellHeadStyle}>Title</TableCell>
            <TableCell sx={tableCellHeadStyle}>Task Order</TableCell>
            <TableCell sx={tableCellHeadStyle}>Task Name</TableCell>
            <TableCell sx={tableCellHeadStyle}>Unit of Measure</TableCell>
            <TableCell sx={tableCellHeadStyle}>Task Type</TableCell>
            <TableCell sx={tableCellHeadStyle} align="center">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>

        {isLoading ? (
          <TableBody>
            <TableRow style={{ height: 300 }}>
              <TableCell colSpan={8} sx={{ textAlign: "center" }}>
                <CircularProgress sx={{ color: "#203c77" }} />
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            {(data ?? []).length > 0
              ? data.map((row: any) => {
                  return (
                    <TableRow key={row.id}>
                      <TableCell width={"140"} scope="row">
                        {row.companyName}
                      </TableCell>
                      <TableCell width={"140"}>
                        {row.organizationName}
                      </TableCell>
                      <TableCell width={"160"}>{row.title}</TableCell>
                      <TableCell width={"50"}>{row.taskOrder}</TableCell>
                      <TableCell width={"160"}>{row.taskName}</TableCell>
                      <TableCell width={"120"}>{row.unitOfMeasure}</TableCell>
                      <TableCell width={"100"}>{row.taskType}</TableCell>
                      <TableCell width={"100"} align="center">
                        <div>
                          <EditButton
                            id={row.id.toString()}
                            onHandleEdit={() => {
                              handleEdit(row.id);
                            }}
                          />
                          <DeleteTaskCounter
                            id={row.id}
                            info={row.taskName}
                            tasks={data}
                            setTasks={setData}
                            setTotalRecords={setTotalRecords}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        )}

        <TableFooterCommon
          data={data}
          rowsPerPage={rowsPerPage}
          page={page}
          totalRecords={totalRecords}
          onHandleChangePage={handleChangePage}
          onHandleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Table>
    </TableContainer>
  );
};
